import { EnvelopeIcon, FacebookIcon, TwitterIcon, CopyIcon } from "styles/icons";
import {
  chakraUseClipboard as useClipboard,
  ChakraStack as Stack,
  ChakraButton as Button,
  ChakraLink as Link,
} from "@airhelp/react-ui-components";
import type { SocialLinksPanelProps } from "./SocialLinksPanel.d";

const SocialLinksPanel = ({ direction = "row", spacing = 4, url, title, ...props }: SocialLinksPanelProps) => {
  const { onCopy } = useClipboard(url);

  return (
    <Stack direction={direction} spacing={spacing} {...props}>
      <Link href={`https://www.facebook.com/sharer.php?u=${url}`} isExternal>
        <Button w={{ base: 12, md: 14 }} h={{ base: 8, md: 10 }} bg="#4267B2" aria-label="Facebook">
          <FacebookIcon w={{ base: 4, md: 6 }} h={{ base: 4, md: 6 }} />
        </Button>
      </Link>
      <Link href={`https://twitter.com/share?text=${title}&url=${url}&via=theairhelper`} isExternal>
        <Button w={{ base: 12, md: 14 }} h={{ base: 8, md: 10 }} bg="#1DA1F1" aria-label="Twitter">
          <TwitterIcon w={{ base: 4, md: 6 }} h={{ base: 4, md: 6 }} />
        </Button>
      </Link>
      <Link href={`mailto:?body=${url}`} isExternal>
        <Button w={{ base: 12, md: 14 }} h={{ base: 8, md: 10 }} bg="primary.500" aria-label="E-mail">
          <EnvelopeIcon w={{ base: 4, md: 6 }} h={{ base: 4, md: 6 }} />
        </Button>
      </Link>
      <Button w={{ base: 12, md: 14 }} h={{ base: 8, md: 10 }} bg="primary.500" onClick={onCopy} aria-label="Copy">
        <CopyIcon w={{ base: 4, md: 6 }} h={{ base: 4, md: 6 }} />
      </Button>
    </Stack>
  );
};

export default SocialLinksPanel;
